<div class="modal-header">
    <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_platform' | translate: lang }}</h5>
    <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
    </button>
</div>
<div class="modal-body">
  <div class="elems">
    <div style="text-align: center" class="elem" (click)="onSelect('pc')">
      <img src="https://cdn.ggboost.com/images/icons/pc.svg" alt="">
      <p class="text-mon mt-2 text-center">PC</p>
    </div>
    <div style="text-align: center" class="elem" (click)="onSelect('psn')">
      <img src="https://cdn.ggboost.com/images/icons/ps.svg" alt="">
      <p class="text-mon mt-2 text-center">PSN</p>
    </div>
    <div style="text-align: center" class="elem" (click)="onSelect('xbox')">
      <img src="https://cdn.ggboost.com/images/icons/xbox.svg" alt="">
      <p class="text-mon mt-2 text-center">XBOX</p>
    </div>
  </div>
</div>
